<template>
<div>
    <form class="box" v-on:submit.prevent>
        <div class="field">
            <div class="control">
                <label class="label">Vorname</label>
                <input class="input" type="text" v-model="user.givenName">
            </div>
        </div>
        <div class="field">
            <div class="control">
                <label class="label">Nachname</label>
                <input class="input" type="text" v-model="user.surname">
            </div>
        </div>
        <div class="field">
            <div class="control">
                <label class="label">Geburtsdatum</label>
                <input class="input" type="date" v-model="birthday">
            </div>
        </div>
       <div class="field">
           <div class="control">
               <label class="label">Aktuell angestebter Abschluss</label>
                <div class="select is-fullwidth">
                    <select v-model="user.currentDegree">
                        <option value="na">Keiner</option>
                        <option>Bachelor</option>
                        <option>Master</option>
                    </select>
                </div>
           </div>
       </div>
       <div class="field">
            <div class="control">
                <label class="label">Letzter Abschluss</label>
                <div class="select is-fullwidth">
                <select v-model="user.lastDegree">
                    <option value="na">Keiner</option>
                    <option>Bachelor</option>
                    <option>Master</option>
                </select>
                </div>
            </div>
       </div>
        <button class="button is-primary is-pulled-right" @click="submit()">Speichern</button>
    </form>
</div>
</template>

<script>
import {API} from '@/assets/ts/api'
export default {
    data() {
        return {
            user: {}
        }
    },
    computed: {
        birthday: {
            get: function() {
                return (((this.user.birthday || '').split('.').reverse().join('-')));
            },
            set: function(value) {
                this.user.birthday = value.split('-').reverse().join('.');
            }
        }
    },
    mounted() {
        API.getMe().then((response) => {
            this.user = response.data
        })
    },
    methods: {
        submit() {
            API.updateMe(this.user);
        }
    }
}
</script>